module.exports = __webpack_public_path__ + "static/media/odin-weather.b984df26.png";